import { styled } from '@linaria/react';

import { Headline } from '~components/Typography';
import { hoverable } from '~theme/snippets';

export const PromoCodeWrapper = styled.div<{ reducedTopMargin: boolean }>`
	--border-r: 62px;
	--padding: 6px 12px;
	display: flex;
	min-height: 60px;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	margin-top: ${({ reducedTopMargin }) => (reducedTopMargin ? '-14px' : '0px')};

	@media screen and (max-width: 380px) {
		margin-top: ${({ reducedTopMargin }) =>
			reducedTopMargin ? '-8px' : '0px'};
	}
`;

export const TextPlaceholder = styled(Headline)`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	padding: var(--padding);
	border-radius: var(--border-r);
	${hoverable};
	background-color: var(--color-white-m);
	gap: 6px;
`;
